/**
 * Calculate the Present Value (PV)
 *
 * @param {number} rate - The rate per period (decimal, e.g., 0.05 for 5%)
 * @param {number} nper - The total number of periods
 * @param {number} payment - The fixed payment made each period
 * @param {number} [fv=0] - The future value (optional, default is 0)
 * @param {boolean} [type=false] - When true, payments are at the beginning of the period; otherwise, they are at the end
 * @returns {number} - The present value
 */
function CalculatePV(
  rateIn,
  nper,
  payment,
  fv = 0,
  type = false,
  positive = true
) {
  if (isNaN(payment) || isNaN(rateIn) || isNaN(nper)) return 0;

  let rate = rateIn / 100 / 12;

  if (rate === 0) {
    const pv = -(payment * nper + fv);
    return positive ? Math.abs(pv) : pv;
  }

  const pvFactor = (1 - Math.pow(1 + rate, -nper)) / rate;
  const adjustment = type ? 1 + rate : 1;
  const pv = -(payment * pvFactor * adjustment + fv / Math.pow(1 + rate, nper));
  return positive ? Math.abs(pv) : pv;
}

export default CalculatePV;
